export function getMaterialRequestDeepLink(
  installationId: unknown,
  materialId: unknown,
): string | null {
  const parsePositiveId = (value: unknown): number | null => {
    if (typeof value !== "number" && typeof value !== "string") return null;
    if (typeof value === "string" && !/^\d+$/.test(value)) return null;
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
  };

  const parsedInstallationId = parsePositiveId(installationId);
  const parsedMaterialId = parsePositiveId(materialId);

  if (parsedInstallationId == null || parsedMaterialId == null) {
    return null;
  }

  const query = new URLSearchParams({
    tab: "requested",
    materialId: String(parsedMaterialId),
  });

  return `/installations/${parsedInstallationId}/materials?${query.toString()}`;
}
